import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import img_gestion_catalogue_1 from "../../images/presentation/gestion_catalogue_1.jpg"
import img_alerte_poche_1 from "../../images/presentation/alerte_poche_1.png"
import img_actualisation_referencement_1 from "../../images/presentation/actualisation_referencement_1.jpg"
//import img_data_control_1 from "../../images/presentation/data_control_1.png"
import img_data_control_sablier_D from "../../images/presentation/data_control_visuel_sablier_sur_grille_D.png" 
import img_data_expert_1 from "../../images/presentation/data_expert_1.jpg"
import img_achat_fichiers_1 from "../../images/presentation/achat_fichiers_1.png"
import "./PagePresentation.scss"
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import CpntBlocPresentation from "../../components/CpntBlocPresentation";




const PagePresentation = () => {

  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const compte = useSelector((state: RootState) => state.compte);

  useEffect(() => {
    if (keycloak.authenticated && compte?.Connected) {
      navigate("/accueil");
    }
  }, [keycloak.authenticated,compte])
  
   return (
    <>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 mb-5">
            <div className="titre titre-Presentation text-center">Editeurs <span className="word">Pros</span></div>
            <div className="description-Titre text-center"><b>Un espace dédié à la gestion de votre catalogue sur electre.com</b></div>
          </div>
        </div>
       <CpntBlocPresentation
          titre="Gestion de votre catalogue"
          description="Accès gratuit à l&apos;intégralité de vos données et interactions avec les experts Electre du catalogage"
          img_gauche={true}
          img_rond={img_gestion_catalogue_1}
          path="/gestion-catalogue"
       />
      <CpntBlocPresentation
          titre="Electre Data Control"
          description="Une solution de pilotage de données dédiée à l'édition : vérifiez la qualité et la cohérence de vos informations bibliographiques dans les plus gros réseaux de vente depuis une interface unique"
          img_gauche={false}
          img_rond={img_data_control_sablier_D}
          path="/data-control"
       />
      <CpntBlocPresentation
          titre="Alerte Poche"
          description="Envoi de notifications à la sortie de vos ouvrages au format poche"
          img_gauche={true}
          img_rond={img_alerte_poche_1}
          path="/alerte-poche"
        />
   
      <CpntBlocPresentation
          titre="Electre Data Expert"
          description="Audit des métadonnées de votre fonds par des experts Electre pour gagner en qualité, efficacité et visibilité"
          img_gauche={false}
          img_rond={img_data_expert_1}
          path="/data-expert"
        />
        <CpntBlocPresentation
          titre="Achat de fichiers"
          description="Fourniture de fichiers personnalisés (listes d&apos;auteurs, ISNI, référentiel)"
          img_gauche={true}
          img_rond={img_achat_fichiers_1}
          path="/achat-fichier"
       />
      <CpntBlocPresentation
          titre="Actualisation du référencement"
          description="	Modernisation de vos anciennes notices pour un référencement optimal"
          img_gauche={false}
          img_rond={img_actualisation_referencement_1}
          path="/actualisation-referencement"
        />
     </>
  );
};

export default PagePresentation;
